module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_innlandet_neg.56fed97f.png";